import { FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useRef } from "react";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";

import { Button } from "@progress/kendo-react-buttons";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { CustomAppDialog } from "../../components/dialog/Dialog";
import { LoadingPanel } from "../../components/layout/Loading";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { ImCross } from "react-icons/im";
import { findAllOrder, findbyOrderNo } from "../order/services/order.services";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { MdOutlineImageNotSupported } from "react-icons/md";
import { FaRegEye } from "react-icons/fa";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import { clearFilterOrder, setFilterOrder } from "../order/orderSlice";
import { closeMinaOrderSelectionDialog } from "./minaSlice";
import { FetchWeight } from "../palish/services/palish.services";
import { PROCESS_ID } from "../../_contstants/common";

interface SelectDialogProps {
  fieldArrayRenderProps: FieldArrayRenderProps;
}

const MinaOrderSelectionDialog = ({
  fieldArrayRenderProps,
}: SelectDialogProps) => {
  const orderList = useAppSelector((state) => state.order.OrderList);
  const MinaOrderSelectionDialog = useAppSelector(
    (state) => state.mina.MinaOrderSelectionDialog,
  );
  const MinaOrderItemIndex = useAppSelector(
    (state) => state.mina.MinaOrderItemIndex,
  );

  const fieldname = fieldArrayRenderProps.name;
  const dispatch = useAppDispatch();

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const loading = useAppSelector((state) => state.order.loading);
  const gridRef = useRef<any>(null);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyImageCommandCell = (props: GridCellProps) => {
    const handlClickItem = (image: string) => {
      if (image && typeof image === "string") {
        window.open(image);
      }
    };
    if (props.dataItem?.image === null) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          <MdOutlineImageNotSupported style={{ fontSize: "30px" }} />
          <p style={{ margin: 0, fontSize: "12px" }}>No Image!</p>
        </div>
      );
    }
    return (
      <td className="action-td main-image">
        <div
          style={{
            position: "relative",
            border: "1px dotted lightgrey",
            borderRadius: "5px",
            height: "50px",
            overflow: "hidden",
          }}
        >
          <img
            className="product-image"
            src={props.dataItem?.image_name}
            alt=""
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              borderRadius: "5px",
            }}
          />
          <div className="image-view">
            <FaRegEye
              style={{
                color: "white",
                height: 24,
                width: 24,
                cursor: "pointer",
              }}
              onClick={() => handlClickItem(props.dataItem?.image_name)}
            />
          </div>
        </div>
      </td>
    );
  };

  const MyEditCommandCell = (props: any) => {
    const handleSelectOrder = async (order_no: number) => {
      const getOrderNowiseData = async () => {
        try {
          const res = await dispatch(
            findbyOrderNo({ order_no, process_id: PROCESS_ID.mina }),
          );
          const updateField = (field: any, value: any) =>
            fieldArrayRenderProps.formRenderProps?.onChange(
              `${fieldname}.${MinaOrderItemIndex}.${field}`,
              { value },
            );
          const prev_process_id =
            fieldArrayRenderProps.formRenderProps?.valueGetter(
              `${fieldname}.${MinaOrderItemIndex}.previous_process_id`,
            );
          const karigar_id =
            fieldArrayRenderProps.formRenderProps?.valueGetter(`karigar_id`);
          const payload = {
            process_id: prev_process_id,
            order_id: res?.payload?.id,
            karigar_id: karigar_id,
          };
          if (res.meta.requestStatus === "fulfilled" && res) {
            updateField("order_id", res?.payload?.id);
            updateField("order_no", res?.payload?.order_no);
            updateField("item_id", res?.payload?.item_id);
            updateField("item_description", res?.payload?.description);
            updateField("remarks", "");
            const response = await dispatch(FetchWeight(payload));
            if (response?.meta?.requestStatus === "fulfilled") {
              updateField("weight", response.payload.Data[0].gross_weight || 0);
            } else {
              updateField("weight", 0);
            }
          }
        } catch (error) {
          console.error(error);
        }
      };
      if (order_no) {
        await getOrderNowiseData();
        dispatch(closeMinaOrderSelectionDialog());
      }
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <Button
          type="button"
          fillMode="solid"
          themeColor={"primary"}
          size="small"
          title="Select Order"
          onClick={() => handleSelectOrder(props.dataItem?.order_no)}
        >
          Select
        </Button>
      </td>
    );
  };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 0 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const OrderFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.order.FilterOrder}
        setFilterAction={setFilterOrder}
        clearFilterAction={clearFilterOrder}
        fetchDataAction={findAllOrder}
        pagination={{ case: "lowercase" }}
        extraPayload={{ ProcessID: PROCESS_ID.mina }}
      />
    ),
    [],
  );

  return (
    <>
      <CustomAppDialog open={MinaOrderSelectionDialog}>
        <div style={{ width: "70vw", minHeight: "30vh" }}>
          {loading && <LoadingPanel gridRef={gridRef} />}
          <GridLayout gap={{ rows: 10, cols: 10 }}>
            <GridLayoutItem
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography.h4>{"Select Order"}</Typography.h4>

              <ImCross
                style={{
                  color: "white",
                  background: "red",
                  borderRadius: "50%",
                  padding: "5px",
                  fontSize: "24px",
                }}
                onClick={() => dispatch(closeMinaOrderSelectionDialog())}
              />
            </GridLayoutItem>

            <GridLayoutItem style={{ overflow: "hidden" }}>
              <KendoGrid
                className="selection-dialog responsive-table"
                style={{ maxHeight: "calc(100vh - 152px)" }}
                filterable={true}
                filter={filter}
                data={filter ? filterBy(orderList, filter) : orderList}
                total={orderList[0]?.itemcount || orderList.length}
                onFilterChange={handleFilterChange}
                skip={currentPage * pageLimit}
                take={pageLimit}
                pageable={{
                  buttonCount: 5,
                  pageSizes: [10, 50, 100, 300, 500],
                  pageSizeValue: pageLimit,
                  type: "input",
                }}
                onPageChange={pageChange}
                cells={{
                  headerCell: HeaderCustomCell,
                  data: MyDataCustomCell,
                }}
              >
                <Column
                  field="image_name"
                  title="Image"
                  width={100}
                  cells={{
                    data: MyImageCommandCell,
                  }}
                  filterable={false}
                />
                <Column
                  field="order_no"
                  title="Order No"
                  width={100}
                  filterable={false}
                  cells={{
                    data: (props: any) => (
                      <td>
                        <div style={{ color: "green" }}>
                          <strong>{props.dataItem?.order_no}</strong>
                        </div>
                      </td>
                    ),
                  }}
                />
                <Column
                  width={200}
                  field="party_name"
                  title="Party Name"
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  width={200}
                  field="item_name"
                  title="Product Name"
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  width={130}
                  field="order_date"
                  title="Order Date"
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  width={130}
                  field="delivery_date"
                  title="Delivery Date"
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="order_no"
                  title="Actions"
                  cells={{ data: MyEditCommandCell }}
                  width={"90px"}
                  filterable={false}
                  locked={true}
                />
              </KendoGrid>
            </GridLayoutItem>
          </GridLayout>
        </div>
      </CustomAppDialog>
    </>
  );
};

export default MinaOrderSelectionDialog;
